module.exports = __webpack_public_path__ + "img/gc.8dddab50.svg";